import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import DashboardBase from "../DashboardBase";
import { getRolDisplay, hasSupeRadminPrivileges } from "../utils/roles";

const ReportesManager = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("🔍 Usuario Firebase:", user.email);
        
        // Si es uno de los usuarios con privilegios especiales de superadmin
        if (hasSupeRadminPrivileges(user.email)) {
          console.log("🎯 Detectado ADMIN PRINCIPAL - Forzando rol superadmin");
          setUserData({
            uid: user.uid,
            email: user.email,
            nombre: user.email === "db@ossinnovation.com" ? "basededatos" : "Administrador",
            apellido: user.email === "db@ossinnovation.com" ? "datos" : "Sistema", 
            rol: "superadmin",
            estado: "activo"
          });
          console.log("✅ ACCESO AUTORIZADO - Admin principal con rol superadmin");
        } else {
          // Buscar datos del usuario en Firestore
          try {
            const q = query(collection(db, "usuarios"), where("uid", "==", user.uid));
            const querySnapshot = await getDocs(q);
            
            if (!querySnapshot.empty) {
              const userDoc = querySnapshot.docs[0];
              const userData = { id: userDoc.id, ...userDoc.data() };
              setUserData(userData);
              console.log('👤 Usuario cargado:', userData);
            } else {
              // Usuario por defecto si no se encuentra en Firestore
              setUserData({
                nombre: "Usuario",
                apellido: "Sistema",
                rol: "admin"
              });
            }
          } catch (error) {
            console.error("Error al cargar datos del usuario:", error);
            setUserData({
              nombre: "Usuario",
              apellido: "Sistema",
              rol: "admin"
            });
          }
        }
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <DashboardBase 
        title="Cargando..." 
        activeNav="reportes"
        userRole={userData ? getRolDisplay(userData.rol) : "Usuario"}
        userName={userData ? `${userData.nombre} ${userData.apellido}` : "Usuario"}
      >
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #1e40af',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p>Cargando reportes...</p>
        </div>
      </DashboardBase>
    );
  }

  return (
    <DashboardBase 
      title="Gestión de Reportes" 
      activeNav="reportes"
      userRole={userData ? getRolDisplay(userData.rol) : "Usuario"}
      userName={userData ? `${userData.nombre} ${userData.apellido}` : "Usuario"}
    >
      <div style={{ padding: '1.5rem' }}>
        <div style={{
          textAlign: 'center',
          padding: '3rem',
          backgroundColor: 'white',
          borderRadius: '8px',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📈</div>
          <h2 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>
            Gestión de Reportes
          </h2>
          <p style={{ margin: 0, color: '#6b7280' }}>
            Esta funcionalidad será implementada próximamente
          </p>
        </div>
      </div>
    </DashboardBase>
  );
};

export default ReportesManager;
